import { combineReducers } from 'redux';
import giftCards from './giftCards/reducer';
import sale from './sale/reducer';
import cashRegister from './cashRegister/reducer';
import summary from './summary/reducer';
import payment from './payment/reducer';
import order from './order/reducer';
import tipping from './tipping/reducer';
import promo from './promo/reducer';
import validated from './validated/reducer';
import customer from './customer/reducer';
import webReader from './webReader/reducer';
import source from './source/reducer';

const reducer = combineReducers({
  sale,
  summary,
  cashRegister,
  giftCards,
  payment,
  order,
  tipping,
  promo,
  validated,
  customer,
  webReader,
  source,
});

export default reducer;
